import { API_METHOD, BASE_URL, HOST_URL, REQUEST_URL } from "../constants/constants"
import { interceptor } from "../interceptor/interceptor"

export const uploadCVS = async(body,type) =>{
    console.log(type,'checktype')
    let token = localStorage.getItem('api-token')
    try{
    let response = await interceptor({
        method:API_METHOD.post,
        url:HOST_URL.url + BASE_URL.employeeUrl + (type === 'Trial' ? REQUEST_URL.uploadEmployees : REQUEST_URL.uploadEmployeesStandard),
        data:body,
        headers:{Authorization:`Bearer ${token}`},
        contentType:'formdata'

    })
    return response
    }
    catch(error){
        console.log(error)
    }
}

export const uploadSingleDemo = async(body,type) =>{
    console.log(body.licenceType,'checktype')
    let token = localStorage.getItem('api-token')
    try{
    let response = await interceptor({
        method:API_METHOD.post,
        url:HOST_URL.url + BASE_URL.employeeUrl +  (body.licenseType === 'Trial' ? REQUEST_URL.addSingleEmployeeDemo : REQUEST_URL.addSingleEmployeeStandard) ,
        data:body,
        headers:{Authorization:`Bearer ${token}`},
        contentType:'application/json'

    })
    return response
    }
    catch(error){
        console.log(error)
    }
}

export const getLicencBatch = async(body) =>{
    let token = localStorage.getItem('api-token')
    try{
    let response = await interceptor({
        method:API_METHOD.get,
        url:HOST_URL.url + BASE_URL.url + REQUEST_URL.licenseBatches ,
        data:body,
        headers:{Authorization:`Bearer ${token}`},
        contentType:'application/json',
    })
    return response
    }
    catch(error){
        console.log(error)
    }
}

export const getAudit = async(body) =>{
    let token = localStorage.getItem('api-token')
    try{
    let response = await interceptor({
        method:API_METHOD.get,
        url:HOST_URL.url + BASE_URL.url + REQUEST_URL.logs ,
        data:body,
        headers:{Authorization:`Bearer ${token}`},
        contentType:'application/json',
    })
    return response
    }
    catch(error){
        console.log(error)
    }
}
export const getAssignAdmin = async(body) =>{
    let token = localStorage.getItem('api-token')
    try{
    let response = await interceptor({
        method:API_METHOD.get,
        url:HOST_URL.url + BASE_URL.url + REQUEST_URL.assignedAdmin ,
        data:body,
        headers:{Authorization:`Bearer ${token}`},
        contentType:'application/json',
    })
    return response
    }
    catch(error){
        console.log(error)
    }
}

export const getPayment = async(id) =>{
    console.log(id,'idinside')
    let token = localStorage.getItem('api-token')
    try{
    let response = await interceptor({
        method:API_METHOD.get,
        url:HOST_URL.url + BASE_URL.licenceUrl + REQUEST_URL.paymentLog + `/${id}` ,
        // data:body,
        headers:{Authorization:`Bearer ${token}`},
        contentType:'application/json',
    })
    return response
    }
    catch(error){
        console.log(error)
    }
}

export const contactUs = async(body) =>{
    let token = localStorage.getItem('api-token')
    try{
    let response = await interceptor({
        method:API_METHOD.post,
        url:HOST_URL.url + BASE_URL.url + REQUEST_URL.contact,
        data:body,
        headers:{Authorization:`Bearer ${token}`},
        contentType:'application/json',
    })
    return response
    }
    catch(error){
        console.log(error)
    }
}




